import {
  Anchor,
  Grid,
  Group,
  Stack,
  Text,
  TextInput,
} from '@mantine/core'

import { IconBan } from '@tabler/icons-react'

import { type DeviceBase } from '@data/device/model/device'
import { ReadOnlyField } from '@components/ui/form/ReadOnlyField'

export interface DeviceNetworkTabProps {
  device: DeviceBase
  // Device Management shows the ICCID and MVNO to device admins only. The Test Bench shows
  // them to everyone who can open it, as its table already does.
  showSimDetails: boolean
}

export const DeviceNetworkTab = ({ device, showSimDetails }: DeviceNetworkTabProps) => {
  const getMVNOLink = (
    iccid: string,
    mvno: string,
  ): string => {
    if (mvno === 'Onomondo') {
      return `https://app.onomondo.com/sims/${iccid.slice(
        10,
        19,
      )}?tab=usage`
    }

    if (mvno === 'Simpl') {
      return `https://app.esimpl.io/manage/inventory/detail?id=${iccid}`
    }

    if (mvno === 'Emnify') {
      return `https://portal.emnify.com/connected-devices?page=1&per_page=100&iccid_with_luhn=${iccid}`
    }

    return ''
  }

  return (
    <Stack gap='lg'>
      {showSimDetails && (
        <Grid>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <Stack gap={4}>
              <Group gap='xs'>
                <Text fw={600}>
                  ICCID
                </Text>

                {device.ICCID &&
                  device.mvno && (
                    <Anchor
                      href={getMVNOLink(
                        device.ICCID,
                        device.mvno,
                      )}
                      target='_blank'
                    >
                      Go to SIM
                    </Anchor>
                  )}
              </Group>

              {device.ICCID ? (
                <TextInput
                  value={device.ICCID}
                  variant='filled'
                  readOnly
                />
              ) : (
                <IconBan size={18} />
              )}
            </Stack>
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 6 }}>
            <Stack gap={4}>
              <Text fw={600}>
                MVNO
              </Text>

              {device.mvno ? (
                <TextInput
                  value={device.mvno}
                  variant='filled'
                  readOnly
                />
              ) : (
                <IconBan size={18} />
              )}
            </Stack>
          </Grid.Col>
        </Grid>
      )}

      <Grid>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <ReadOnlyField
            label='Network Name'
            value={device.networkName || ''}
            enableClipboard
          />
        </Grid.Col>

        <Grid.Col span={{ base: 12, md: 6 }}>
          {device.signal ? (
            <ReadOnlyField
              label='CSQ'
              value={String(device.signal)}
              enableClipboard
            />
          ) : (
            <Stack gap={4}>
              <Text fw={600}>
                CSQ
              </Text>

              <IconBan size={18} />
            </Stack>
          )}
        </Grid.Col>
      </Grid>
    </Stack>
  )
}